import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {closeNavHelp} from '../../actions/navOptions';
import { CONTACT_INFO } from '../../constants';

class HelpPage extends Component {

  render() {
    const {closeNavHelp} = this.props;

    const { name = '', email = '', telephone = '' } = CONTACT_INFO;

    return (
      <div className="map-page map-page__default">
        <div className="map-page-content" id="page-help">
          <div className="map-page-content-head clearfix">
            <h2 className="pull-left">
              <div className="icon-help" />
              Help
            </h2>
            <a href="#" className="close-it hide-map-page pull-right" onClick={closeNavHelp}>&times;</a>
          </div>

          <div className="map-page-body">
            <h4>Need some help?</h4>
            <strong>Contact {name}</strong>

            <h4>{telephone}</h4>
            <h4>
              <a href="mailto:{email}">
                {email}
              </a>
            </h4>

          </div>

          <div className="map-page-content-footer">
            {/*<!-- <hr>*/}
            {/*<a href="" className="btn btn-default hide-map-page btn-block btn-lg">Close</a> -->*/}
          </div>
        </div>
      </div>
    );
  }

}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ closeNavHelp }, dispatch);
}

export default connect(undefined, mapDispatchToProps)(HelpPage);



// WEBPACK FOOTER //
// ./src/containers/NavOptions/HelpPage.js